export const compressItem = [
    'test_tttrack',
    'pc_restartApplication',
    'pcMail_view_mailDetailPage_agent',
    'pcMail_inputMessageBody_writeMailPage',
    'pcMail_input_searchContent_searchInputBox',
    'read_mail_img_error',
    'pcMail_click_switchSender__writeMailPage',
    'pc_upgrade_check',
    'pc_upgrade_local_exist_file',
    'pcMail_click_searchInputBox_topBar',
    'pcMail_click_checkbox',
    'pcMail_click_enter_keyboard',
    'pcContact_view_contactsDetailPage',
    'pcMail_dragFile_writeMailPage',
    'pcLogin_show_QRcode_loginPage',
    'pc_register_mobile_code_page',
    'pc_no_account_select_action_page',
    'pcMail_click_mailReadingState_readMailPage',
    'second_check_auth_ok',
    'pcMail_limit_LoginDetailPage_agent',
    'pcMail_view_writeMailPage',
    'pc_getMyCustomerDataByIds_max_limit_error',
    'pc_upgrade_local_exist_file_forcePopup',
    'pc_upgrade_needUpdate',
    'pc_upgrade_needUpdate_ignoreUpdate',
    'pc_upgrade_needUpdate_noFileUrl',
    'pc_upgrade_checkFileUrl',
    'pc_upgrade_checkFileUrl_fail',
    'pc_upgrade_checkFileUrl_success',
    'pc_upgrade_download_success',
    'pc_upgrade_download_fail',
    'waimao_mail_sidebar_AIdigging',
    'pc_markting_customs_data_companydetail_viewtickets',
    'pc_markting_all_search_do_search',
    'WA_account_management_business_add_assign',
    'WA_account_management_business_cancel_assign',
    'WA_account_management_business_users',
    'WA_account_management_bussiness_chatrecord',
    'WA_account_management_personal_number_record',
    'WA_account_management_business_account',
    'pcLogin_click_free',
    'pc_register_improve_team_information_page',
    'waimao_address_book',
    'waimao_address_book_sea',
    'pc_markting_newobject_edm_click',
    'jz_product_click',
    'jz_product_message_success',
    'waimao_worktable_videolink_click',
    'waimao_worktable_videolink_viewmoreclick',
    'pc_markting_edm_template_management_click',
    'pc_leftNavigationBarTab_waimaoShow',
    'pc_waimaoAttracts_show',
    'pcMail_click_open_sidebar_mailfolder',
    'pcMail_click_close_sidebar_mailfolder',
    'pc_click_update_leftSideBar',
    'pcMineCenter_click_usageManual',
    'pcMineCenter_click_helperCenter',
    'waimao_ai_master_click',
    'pcMail_click_submit_addStarContactPage',
    'pcContact_click_contactsDetailPage_seeTheMedal',
    'pc_disk_click_share',
    'pc_disk_click_share_favorites',
    'pc_markting_edm_taskList_remarkting',
    'email_addgoods_click',
    'pc_marketing_edm_writing_guide_view',
    'pc_marketing_edm_writing_guide_product_click',
    'pc_marketing_edm_writing_guide_product_success_click',
    'pc_markting_edm_variable_add',
    'pc_markting_edm_variable_manage',
    'product_select_add_click',
    'pc_markting_edm_template_search',
    'pc_markting_edm_taskdetail_save_as_template_click',
    'pc_markting_edm_template_group_click',
];
